import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { defaultThemeStyles } from '../CatalogFilter-theme'
import { defaultThemeStyles as defaultThemeAppStyles } from 'blocks.app/app/app.theme.jcss'

const instancesCatalogFilterStyles = {
    wrapper: {
        ...grid.w100,
        ...grid.mt_md,
    },
    content: {
        ...item.rounded_top_mini,
        borderRadius: '5px 5px 0 0',
        backgroundColor: `var(--var-module-catalog-component-filter-style-background, ${defaultThemeStyles.background})`,
    },
    tools: {
        ...grid.row,
        ...grid.justify,
        ...grid.normalCenter,
        ...grid.pr_md,
        ...grid.pl_md,
        borderBottom: `1px solid var(--var-module-app-component-app-style-border, ${defaultThemeAppStyles.border})`,
    },
    deleteButton: {
        width: 250,
    },
}

addStyles(instancesCatalogFilterStyles)
export default instancesCatalogFilterStyles
